export default "__VITE_ASSET__C8r5aiKl__"